//Upload Reports
export const CUSTOMER_FILE_TYPES_SUCCESS = "CUSTOMER_FILE_TYPES_SUCCESS";
export const CUSTOMER_FILE_TYPES_FAILURE = "CUSTOMER_FILE_TYPES_FAILURE";
